import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import { PublicRoutes, PrivateRoutes } from "./configs";
import { isAuthenticated } from "../services/authenticationChecker";
import Loading from "../components/Loading/Loading";

const ConstructRoutes = (routes) =>
  routes.map(
    ({ path, component: Component, layout: Layout, props: Props, layoutProps }, index) => {
      return (
        <Route
          key={index}
          path={path}
          exact
          render={(props) => {
            const totalProps = { ...props, ...Props };
            return (
              <Suspense fallback={<Loading />}>
                <Layout {...layoutProps}>
                  <Component {...totalProps} />
                </Layout>
              </Suspense>
            );
          }}
        />
      );
    }
  );

const Routes = (props) => (
  <Switch>
    {ConstructRoutes(isAuthenticated() ? PrivateRoutes : PublicRoutes)}
    {isAuthenticated() ? (
      <Redirect to="/"></Redirect>
    ) : (
      <Redirect to="/signin"></Redirect>
    )}
  </Switch>
);

export default Routes;
